<template>
    <div>
        <!-- <p class="heading">View Past Billing</p>
        <hr>
        <b-row clas="mb-5">
            <div class="col-6">
                <p>Payment Method</p>
            </div>
            <div class="col-5">
                <p class="card-statement"> {{ cardName }} ending in {{ cardNumber }}, exp: {{ expiryDate }}</p>
            </div>
            <div class="col-1">
                <button class="update-button">Update</button>
            </div>
        </b-row> -->
        <div class="plan-div">
            <div class="row">
                <div class="col-6 ">
                    <p class="plan-row mb-0">Current Plan</p>
                </div>
                <div class="col-6">
                    <p class="amount-statement mb-0">$ {{ planAmount }} (taxes included) per month</p>
                </div>
            </div>
            <div class="row">
                <div class="col-6 mb-0">
                    <p class="plan-type-row">{{ planType }}</p>
                </div>
                <div class="col-6">
                    <p class="renewal">Next renewal on {{ renewalDate }}</p>
                </div>
            </div>
        </div>


        <hr>
        <p class="mb-0">Billing History</p>
        <p class="subtitle mb-3">View invoices and receipts for all payments made on your EliteFit.AI account.</p>
        <div class="transaction-table">
            <b-table class="mx-5" hover :items="rows" :fields="fields" :busy="isLoading">
            </b-table>
        </div>
    </div>
</template>

<script>
import API from "../api.js"
export default {
    name: "ReportingDashboard",
    data() {
        return {
            fields: [
                { key: 'date' },
                { key: 'description' },
                { key: 'invoice' },
                { key: 'amount' },
            ],
            cardName: "MasterCard",
            cardNumber: "1234",
            expiryDate: "01/1234",
            planAmount: "",
            planType: "",
            renewalDate: ""
        }
    },
    methods: {
        formatDate(isoDateString) {
            const date = new Date(isoDateString);
            const formattedDateString = date.toLocaleString("en-US", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            });
            return formattedDateString.split(",")[0];
        },

        async transactionRows() {
            try {
                let res = await API.getTransactions()
                this.rows = []
                res.data.rows.forEach((item) => {
                    this.rows.push({
                        date: this.formatDate(item.startTimestamp),
                        description: item.name + ' (' + this.formatDate(item.startTimestamp) + ' to ' + this.formatDate(item.endTimestamp) + ')',
                        invoice: 'Invoice',
                        amount: item.amount
                    });
                });
                this.planAmount = this. rows[0].amount;
                this.planType = res.data.rows[0].name;
                this.renewalDate = this.formatDate(res.data.rows[0].endTimestamp);
                console.log("rows", this.rows);
            }
            catch (error) {
                console.log("There is an error in getting transactions", error);
            }
        }
    },
    mounted() {
        this.transactionRows();
    },
}
</script>

<style lang="scss" scoped>
.heading {
    font-weight: bold;
    font-size: 1.5rem;
}

.subtitle {
    font-size: 0.7rem;
}

.card-statement {
    text-align: right;
}

.update-button {
    border: 0px;
    font-weight: bold;
}

.plan-div {
    background-color: #eeeded;
    margin-left: 50px;
    margin-right: 100px;
}

.plan-row {
    font-size: 0.8rem;
    font-weight: bold;
    padding: 10px 10px 0px 10px;
}

.amount-statement {
    text-align: right;
    font-size: 0.8rem;
    padding: 10px 10px 0px 10px;
}

.plan-type-row {
    font-size: 0.8rem;
    padding: 0px 10px 0px 10px;
}

.renewal {
    font-size: 0.8rem;
    padding: 0px 10px 0px 10px;
    text-align: right;
}
</style>